module.exports = __webpack_public_path__ + "img/new-board-icon.4d0fc125.svg";